<form name="filter" class="search-form">
  <div class="input-group">
    <span class="input-group-addon">
      <i class="fa fa-search"></i>
    </span>
    <input type="text" name="search" placeholder="Buscar..." class="form-control"
           ng-model="hist.filters.search" ng-model-options="{ debounce: 500 }"
           ng-change="hist.checkForFilters()">
    <span class="input-group-btn">
      <button type="button" class="btn btn-link" ng-click="hist.showFilters()" ng-class="{ active: hist.hasFilters }"
              uib-tooltip-template="'filter-tooltip.html'" tooltip-append-to-body="true" tooltip-placement="bottom-right">
        <i class="fa fa-filter"></i>
      </button>
    </span>
    <span class="input-group-btn" ng-if="hist.hasFilters || hist.filters.search">
      <button type="button" class="btn btn-link clear" ng-click="hist.clearFilters()"
              uib-tooltip="Limpar filtros" tooltip-append-to-body="true" tooltip-placement="bottom-right">
        <i class="fa fa-close"></i>
      </button>
    </span>
  </div>
</form>

<propriedade-cards filters="hist.filters"
                   is-historico="true"
                   unread-histories="hist.unreadHistories"
                   culturas-por-gleba="culturasPorGleba"></propriedade-cards>

<button type="button" uib-tooltip="Voltar ao topo" class="back-to-top" tooltip-append-to-body="true" ng-click="hist.scrollToTop()">
  <i class="fa fa-arrow-up"></i>
</button>

<script type="text/ng-template" id="filter-tooltip.html">
  <div class="text-left">
    <h4 class="m-b-none">Filtros avançados</h4>
    <p class="m-b-none">
      <b>Tipo:</b> {{hist.filtersTitles.tipos}} <br>
      <b>Cultura:</b> {{hist.filtersTitles.culturas}} <br>
      <b>Usuário:</b> {{hist.filtersTitles.usuarios}}
    </p>
  </div>
</script>
